<template>
  <div id="view-order">
    <v-container class="padding-40-small-top">
      <v-layout row wrap>
        <v-flex xs12>
          <h1 class="headline">Bedankt voor je bestelling</h1>
          <br>
          <h2 class="order">Je kunt je pasfoto's ophalen bij:</h2>
          <address>
            Adres van de winkel hier
          </address>
          <br>
        </v-flex>
        <v-flex xs12>
          <h2 class="order">Je bestelcode is:</h2>
          <v-card class="mt-3">
            <v-card-title primary-title class="justify-center">
              <div>
                <h3 class="display-2 font-weight-bold" v-text="order_code"></h3>
              </div>
            </v-card-title>
          </v-card>
          <p class="mt-2 mb-2">Deze code heb je nodig om jouw pasfoto's op te halen. De code zal ook per e-mail worden toegezonden.</p>
        </v-flex>
      </v-layout>
      <v-footer ref="footer" fixed color="white" height="auto" class="background-white">
        <v-container class="pa-0" fluid style="padding-top: 0">
          <v-layout row wrap>
            <v-flex xs12>
              <v-btn block color="accent" class="v-btn--block--footer" dark @click="$router.push('/photo')">Startpagina <i class="icon icon-kruidvat-arrow icon-white"></i></v-btn>
              <div class="v-btn--footer--direct_photo"><a href="https://www.kruidvat.nl/" target="_blank">Naar kruidvat.nl</a></div>
            </v-flex>
          </v-layout>
        </v-container>
      </v-footer>
    </v-container>
  </div>
</template>

<script>

  import BackendService from "@/services/BackendService";

  export default {
    name: 'order',
    data() {
      return {
        store_id: 0,
        order_code: '......'
      }
    },
    mounted() {
      if (localStorage.lastOrderCode) {
        this.order_code = localStorage.lastOrderCode;
      }
      this.getOrderStatus();
    },
    watch: {
      '$route':'getOrderStatus'
    },
    methods: {
      getOrderStatus() {
        let key = localStorage.photoKey;
        let token = localStorage.accessToken;
        BackendService.getOrder(key,token)
          .then((response) => {
            console.log(response.data);
            this.order_code = response.data.order_code;
            localStorage.lastOrderCode = this.order_code;
          })
          .catch((error) => {
            console.log('API ERROR',error);
          })
      }
    },
  };
</script>

<style scoped>

  body {
    background-color: #F0F0F0;
  }

  #camera {
    /*text-align: center;*/
    /*color: #2c3e50;*/
    /*margin-top: 60px;*/
  }

  #wrapper-background {
    background: #000;
  }

  .errors {
    background: rgba(0, 0, 0, 0.4);
    color: white;
    padding: 8px;
    position: absolute;
  }

  .errors li {
    display: list-item;
  }

  #errors-face {
    width: 200px;
    height: 300px;
    margin-left: -100px;
    margin-top: -150px;
    left: 50%;
    top: 50%;
  }

  #wrapper {
    position: relative;
    overflow: hidden;
    margin: 0 auto;
  }

  #scanning-overlay {
    position: absolute;
    font-size: 18px;
    color: yellow;
    text-transform: uppercase;
    font-weight: bold;
    top: 20px;
    left: 20px;
  }

  li {
    display: inline;
    padding: 5px;
  }

  video {
    background: #000;
    object-fit: cover;
  }
</style>
